"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _reactCountup = require("react-countup");
var _react = _interopRequireWildcard(require("react"));
var _HBText = _interopRequireDefault(require("../HBText/HBText"));
var _excluded = ["start", "end", "duration"];
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-enable import/no-extraneous-dependencies */
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var HBCountUp = function HBCountUp(_ref) {
  var _ref$start = _ref.start,
    start = _ref$start === void 0 ? 0 : _ref$start,
    end = _ref.end,
    _ref$duration = _ref.duration,
    duration = _ref$duration === void 0 ? 1 : _ref$duration,
    textProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var ref = (0, _react.useRef)(null);
  var _useCountUp = (0, _reactCountup.useCountUp)({
      ref: ref,
      start: start,
      end: end,
      duration: duration,
      useEasing: true,
      easingFn: easeInOutCubic
    }),
    update = _useCountUp.update;
  (0, _react.useEffect)(function () {
    return update(end);
  }, [update, end]);
  if (textProps.type) {
    // @ts-ignore
    return /*#__PURE__*/_react["default"].createElement(_HBText["default"], (0, _extends2["default"])({
      ref: ref
    }, textProps));
  }
  return /*#__PURE__*/_react["default"].createElement("span", {
    ref: ref
  });
};
var _default = exports["default"] = HBCountUp; // If you want a different curve, propify 'easingFn' and add a new easing function from:
// https://github.com/danro/jquery-easing/blob/master/jquery.easing.js
/* eslint-disable no-param-reassign */
var easeInOutCubic = function easeInOutCubic(t, b, c, d) {
  if ((t /= d / 2) < 1) {
    return c / 2 * t * t * t + b;
  }
  return c / 2 * ((t -= 2) * t * t + 2) + b;
};
//# sourceMappingURL=HBCountUp.js.map